import { CloudinaryImage } from "@/features/common/components/CloudinaryImage";
import { PrivateAlbumButtonOverlay } from "@/features/modelPhoto/components/PrivateAlbumButtonOverlay";
import {
  ModelPhotoFragment,
  ModelWithPrivateInfoFragment,
} from "@/generated/graphql-hooks";

export const PrivatePreviewButton = ({
  model,
  modelPrivatePreviewPhoto,
}: {
  model: ModelWithPrivateInfoFragment;
  modelPrivatePreviewPhoto: ModelPhotoFragment;
}) => {
  return (
    <div className="relative mb-2 min-h-[7rem] w-full rounded-lg">
      <PrivateAlbumButtonOverlay
        modelId={model.id}
        canAccessPrivate={model.canAccessPrivate}
      />

      <CloudinaryImage
        className="rounded-lg"
        publicId={modelPrivatePreviewPhoto.publicId}
        alt="preview"
        width={modelPrivatePreviewPhoto.width}
        height={modelPrivatePreviewPhoto.height}
        key={modelPrivatePreviewPhoto.id}
      />
    </div>
  );
};
